import React from 'react';

import Actions from 'flow/actions';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { selectCompanionRoleLost } from 'flow/selectors/app-selectors';

/**
 * Says that another of the user's machines has taken the companion role, and that this one has
 * stood down.
 *
 * Worth an interruption because the change is invisible otherwise: a setting the user turned on
 * here has been turned off by something they did somewhere else, and on a machine that started
 * into the tray the window it happened in was not even on screen - the app puts itself up to show
 * this. Without it a person would find their desktop app silently no longer taking calls and
 * nothing to explain when or why.
 *
 * Only informs. Claiming the role back is the toggle in Settings, deliberately: taking media
 * ownership away from the machine the user is sitting at now should be a thing they choose, not a
 * button they dismiss a banner with.
 */
const CompanionRoleLostNotifier = () => {
    const roleLost = useAppSelector(selectCompanionRoleLost);
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    if (!roleLost) {
        return null;
    }

    return (
        <NotifierBanner
            message={i18next.t('companion.roleLost.message')}
            buttonText={i18next.t('dismiss')}
            handleClick={() =>
                dispatch({
                    type: Actions.APP_COMPANION_ROLE_LOST,
                    lost: false,
                })
            }
        />
    );
};

export default CompanionRoleLostNotifier;
